import { useMemo, useState } from 'react';

import SeasonSummaryWidgetLayout from './SeasonSummaryWidgetLayout';
import AgronomistTable from './agronomist/AgronomistTable';
import PlantingGroupsTable from './planting-groups/PlantingGroupsTable';

import useNotifyError from 'hooks/useNotifyError';
import useSeasonSummaryQuery from 'screens/season-overview/hooks/useSeasonSummaryQuery';

import type {
  AgSeasonSummary,
  PlantingGroupSeasonSummary,
  SeasonOverviewCommonWidgetFilters as SeasonOverviewCommonWidgetProps,
} from 'screens/season-overview/types';

type DataKey = 'agronomist' | 'planting-group';

const SeasonSummaryWidget = ({
  country,
  seasonTypeId,
}: SeasonOverviewCommonWidgetProps) => {
  const [selectedTab, setSelectedTab] = useState<DataKey>('agronomist');

  const params = useMemo(
    () => ({
      country,
      seasonTypeId,
      viewType:
        selectedTab === 'agronomist' ? 'ag_target_table' : 'pg_target_table',
    }),
    [seasonTypeId, country, selectedTab],
  );
  const {
    data: seasonSummaryData,
    isLoading: isSeasonSummaryLoading,
    error: seasonSummaryError,
  } = useSeasonSummaryQuery(params);

  useNotifyError({
    error: seasonSummaryError,
    msg: 'Could not fetch season summary, Please try again.',
  });

  return (
    <SeasonSummaryWidgetLayout
      selectedTab={selectedTab}
      onSelectedTabChange={setSelectedTab}
    >
      <>
        {selectedTab === 'agronomist' && (
          <AgronomistTable
            currency={country === 'Indonesia' ? 'Rp' : '₫'}
            data={seasonSummaryData as AgSeasonSummary[]}
            isLoading={isSeasonSummaryLoading}
            country={country}
            seasonTypeId={seasonTypeId}
          />
        )}
        {selectedTab === 'planting-group' && (
          <PlantingGroupsTable
            currency={country === 'Indonesia' ? 'Rp' : '₫'}
            data={seasonSummaryData as PlantingGroupSeasonSummary[]}
            isLoading={isSeasonSummaryLoading}
          />
        )}
      </>
    </SeasonSummaryWidgetLayout>
  );
};

export default SeasonSummaryWidget;
